
import React, { Component } from 'react'
import { Form, Input, Modal, Button, Typography } from 'antd';
import { MailOutlined, KeyOutlined } from '@ant-design/icons';
import '../../Styles/Global/auth.css';

const axios = require("axios").default;

const { Title, Text } = Typography;

/**
 *
 *
 * @class Recovery
 * @extends {Component}
 */
class Recovery extends Component {

    /**
     *Creates an instance of Login.
     * @param {*} props
     * @memberof Login
     */
    constructor(props) {
        super(props);
        this.state = {
            statusLoading: 0,
            isRecovery: false,
            isRecoveryLoading: false
        }
    }

    recoveryPassword = React.createRef();
    /**
   * @memberof Login
   * @method   handleRecoveryPassword
   * @description Metodo de recuperación de contraseña
   *
   **/
    handleRecoveryPassword = async value => {
        await this.setState({
            isRecoveryLoading: true
        })
        axios.put("/password/recovery", { email: value.email })
            .then(res => {
                this.setState({
                    isRecovery: false
                })
                Modal.success({
                    title: 'Restablece tu contraseña.',
                    content: '¡El correo ha sido enviado! Revisa tu bandeja de entrada.'
                })
                this.props.hideModal()
                this.recoveryPassword.current.resetFields();
            })
            .catch(res => {
                console.log(res)
                Modal.warning({
                    title: 'Error',
                    content: 'El correo no se ha podido enviar. Verifica que sea el mismo con el que te registraste.'
                });
            })
            .finally(() => {
                this.setState({
                    isRecoveryLoading: false
                })
            })
    }

    /**
    * @memberof Login
    *
    * @method redirectTo
    * @description  Redirecciona a cierto link.
    *
    **/
    redirectTo = (to) => {
        this.redirectLink = to;
    }


    render() {
        return (
            <Form onFinish={this.handleRecoveryPassword} layout={"vertical"} requiredMark={false} className="login-form recovery-form" ref={this.recoveryPassword}>
                <div className="login-header">
                    <div className="recovery-icon">
                        <KeyOutlined />
                    </div>
                    <Title level={3} className="h3-title login-title">Restablecer contraseña</Title>
                    <Text className="login-subtitle">
                        Escribe tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                    </Text>
                </div>
                <Form.Item
                    name="email"
                    label="Correo electrónico"
                    rules={[
                        {
                            required: true,
                            message: 'Por favor, ingresa tu correo electrónico.'
                        },{
                            type: 'email',
                            message: 'Por favor, ingresa un correo electrónico válido.',
                        },
                    ]}>
                    <Input
                        type="email"
                        size="large"
                        placeholder="correo@ejemplo.com"
                        className="login-input"
                        prefix={<MailOutlined className="login-input-icon" />}
                        autoComplete="email"
                        autoFocus
                    />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                    <Button
                        htmlType='submit'
                        type="primary"
                        block
                        size="large"
                        className="button-login login-button"
                        loading={this.state.isRecoveryLoading}
                    >
                        Enviar enlace
                    </Button>
                </Form.Item>
                <div className="login-register">
                    <a onClick={this.props.hideModal} className="login-link">Cancelar</a>
                </div>
            </Form>
        )
    }
}

/**
 *@function ModalRecovery
 *@description 
 */
export default function (props) {
    return (
        <Modal
            visible={props.visible}
            onCancel={props.hideModal}
            title={null}
            footer={null}
            closable={true}
            maskClosable={true}
            centered
            width={460}
            className="recovery-modal"
            destroyOnClose={true}
            zIndex={1000}
        >
            <Recovery {...props} />
        </Modal>
    )
}
